import { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { useAppStore } from "../../store";
import { AssessmentMetadata } from "../../types";

interface MetadataDialogProps {
  open: boolean;
  onClose: () => void;
}

export function MetadataDialog({ open, onClose }: MetadataDialogProps) {
  const { assessment, setMetadata } = useAppStore();

  const [formData, setFormData] = useState<AssessmentMetadata>({
    company: "",
    assessor: "",
    date: "",
    notes: "",
  });

  useEffect(() => {
    if (open) {
      setFormData({
        company: assessment.metadata?.company || "",
        assessor: assessment.metadata?.assessor || "",
        date: assessment.metadata?.date || "",
        notes: assessment.metadata?.notes || "",
      });
    }
  }, [open, assessment.metadata]);

  const handleSave = () => {
    const metadata: AssessmentMetadata = {};
    if (formData.company?.trim()) metadata.company = formData.company.trim();
    if (formData.assessor?.trim()) metadata.assessor = formData.assessor.trim();
    if (formData.date?.trim()) metadata.date = formData.date.trim();
    if (formData.notes?.trim()) metadata.notes = formData.notes.trim();

    setMetadata(Object.keys(metadata).length > 0 ? metadata : undefined);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Assessment Details</DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
          <TextField
            label="Company / Client Name"
            value={formData.company || ""}
            onChange={(e) =>
              setFormData({ ...formData, company: e.target.value })
            }
            fullWidth
            autoFocus
          />
          <TextField
            label="Assessor Name"
            value={formData.assessor || ""}
            onChange={(e) =>
              setFormData({ ...formData, assessor: e.target.value })
            }
            fullWidth
          />
          <TextField
            label="Assessment Date"
            type="date"
            value={formData.date || ""}
            onChange={(e) => setFormData({ ...formData, date: e.target.value })}
            fullWidth
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            label="Notes"
            value={formData.notes || ""}
            onChange={(e) =>
              setFormData({ ...formData, notes: e.target.value })
            }
            fullWidth
            multiline
            rows={3}
            placeholder="Additional notes about this assessment..."
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSave} variant="contained">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
